import Axios, { Response } from "../utils/Axios";

export type storeMarketingInfo = {
  content_url_path: string;
  created_at: string;
  has_content: number;
  id_order: number;
  is_required: number;
  status: number;
  terms_id: number;
  terms_title: string;
  terms_type: string;
  updated_at: string;
};

export type storeExtraType = {
  address1: string;
  address2: string;
  business_number: string;
  city: string;
  description: string;
  description_extra: string;
  description_holiday: string;
  description_noti: string;
  first_name: string;
  full_name: string;
  last_name: string;
  parking_pan: string;
  parking_tilt: string;
  parking_zoom: number;
  phone_number: string;
  postcode: string;
  province: string;
  store_id: number;
  trademark_name: string;
};

export type storeImageType = {
  img_detail_album: any[];
  img_detail_thumb: string;
  img_main_size: imageSizeType;
};

export type imageSizeType = {
  height: number;
  width: number;
};

export type categoryType = {
  category_id: number;
  category_name: string;
  category_store_confirmed: number;
  product_list: productType[];
};

export type productType = {
  is_soldout: number;
  is_throo_only: number;
  option_id: number;
  options: any[];
  prd_base_price: string;
  prd_base_price_nrm: string;
  prd_base_price_option: string;
  prd_base_price_option_nrm: string;
  prd_description: string;
  prd_discount_direction: string;
  prd_discount_percentage: number;
  prd_discount_percentage_nrm: string;
  prd_id: number;
  prd_name: string;
  prd_name2: string | null;
  prd_name_truncated: string;
  prd_name_truncated_long: string;
  prd_org_price: string;
  prd_org_price_nrm: string;
  url_path: string;
  url_path_big: string;
};

export type productOptionType = {
  // image_album: string[];
  // image_main_size: any;
  options: object;
  // store_availability: string;
  // store_availability_msg: string;
  // store_data: object;
  success: boolean;
  option_type_list: any;
};

export type optionsType = {
  option_id: number;
  option_id_order: number;
  option_input_max: number;
  option_input_min: number;
  option_input_type: string;
  option_is_default: number;
  option_name: string;
  option_name2: string | null;
  option_prd_id: number;
  option_price: string;
  option_price_nrm: string;
  option_required: false;
  option_sold: string;
  option_type_code: string;
  option_type_id: number;
  option_type_name: string;
  option_type_name2: string | null;
  option_type_order: number;
};

export type trayInfoType = {
  quantity: number;
  inquiry: string;
  prd_img: string[];
  prd_id: number;
  prd_name: string;
  total_price: number;
  options: optionsType[];
};

export type reviewType = {
  created_at: string;
  created_at_show: string;
  deleted_at: string | null;
  field_data: any;
  img_list: string[];
  img_url1: string | null;
  img_url2: string | null;
  img_url3: string | null;
  is_deleted: number;
  masking_nick: string;
  order_id: number;
  review_content: string;
  review_id: number;
  store_comment: string | null;
  store_deleted_at: string | null;
  store_id: number;
  store_is_deleted: number;
  store_updated_at: string | null;
  store_updated_at_show: string;
  updated_at: string | null;
  user_id: number;
  view_status: number;
};

// knockknock
// knockknock
// 매장정보
export type storeType = {
  store_name: string;
  store_img_url: string;
  store_id: number;
};

// 메뉴정보
export type CategoryType = {
  category_id: number;
  category_name: string;
  category_name2: string;
  product_list: ProductType[];
};
export type ProductType = {
  is_soldout: number;
  prd_base_price: string;
  prd_base_price_nrm: string;
  prd_description: string;
  prd_org_price: string;
  prd_org_price_nrm: string;
  prd_id: number;
  prd_name: string;
  prd_name2: string;
  url_path: string;
};

// 옵션정보
export type optionGroupType = {
  option_input_max: number;
  option_input_min: number;
  option_list: optionType[];
  option_required: boolean;
  option_type_id: number;
  option_type_name: string;
  option_type_name2: string | null;
  option_type_order: number;
};
export type optionType = {
  option_id: number;
  option_name: string;
  option_name2: string | null;
  option_price: string;
  option_price_nrm: string;
};

const StoreController = {
  //getStoreData가져오기
  getMenuByStoreLoginId: async (storeId: number): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + `/store/getStoreData`;
      const data = {
        store_id: storeId,
      };

      const response: any = await Axios.post(sUrl, data);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[메뉴 불러오기 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  getPosStoreData: async (storeId: number): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + `/store/getPosStoreData`;
      const data = {
        store_id: storeId,
      };

      const response: any = await Axios.post(sUrl, data);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[매장 불러오기 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  setAutoConfirmed: async (
    storeId: number,
    authConfirmed: boolean
  ): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + `/store/setAutoConfirmed`;
      const data = {
        store_id: storeId,
        auto_confirmed: authConfirmed ? 1 : 0,
      };

      const response: any = await Axios.post(sUrl, data);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[자동접수 저장 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  // getMenuOptions: async (productId: number): Promise<Response> => {
  //   try {
  //     let sUrl = process.env.REACT_APP_API_URL + `/product/getOptions`;
  //     const data = {
  //       product_id: productId,
  //     };
  //     const response: any = await Axios.post(sUrl, data);
  //     return response;
  //   } catch (err) {
  //     let oErr: any = err;
  //     return {
  //       ok: false,
  //       msg: "[옵션 불러오기 오류]" + oErr.toString(),
  //       data: undefined,
  //       status: 500,
  //     };
  //   }
  // },
};

export default StoreController;
